// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NtYT","title":"Header_title__1_aiA","left":"Header_left__3W3EX","clinicName":"Header_clinicName__1YI5c"};